import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { InvestmentItemModel } from 'src/app/model/investment-item.model';
import { AppButtonComponent } from '@ifaa-components/ui-components';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { AnimateCssDirective } from 'src/app/directives/animatecss.directive';
import { InvestmentTooltipComponent } from '../investment-tooltip/investment-tooltip.component';

@Component({
    selector: 'app-investment-card',
    templateUrl: './investment-card.component.html',
    styleUrls: ['./investment-card.component.scss'],
    imports: [
        AppButtonComponent,
        InvestmentTooltipComponent,
        NgIf,
        MatIcon,
        AnimateCssDirective
    ],
})
export class InvestmentCardComponent
    extends ComponentBase
    implements OnInit, OnDestroy {

    @Output() onSelected = new EventEmitter<any>();

    @Input() set option(value: InvestmentItemModel) {
        this.investmentOption = value;
    }

    @Input() set leftValue(value: string){
        this.left = value;
    }

    investmentOption: InvestmentItemModel = null;
    left:string = null;
    riskTooltip: string = 'The Risk Band is based on regulated Standard Risk Measure guidelines.';
    timeframeTooltip: string = 'Suggested Minimum Timeframe: Your investment time horizon is your game plan AKA how long you’re investing to reach your goals. Having a longer timeline means you can go bolder with high-growth options. If your timeline is shorter a steadier approach might suit you. It’s all about balancing risk and reward with confidence.';

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    onSelect() {
        this.onSelected.emit(this.investmentOption?.investmentOptionId)
    }
}
